<template>
  <div :class="{'actionlog-top-foldout': true, 'active': show}">
    <div class="arrow filter"></div>
    <div class="content">
      <div class="field">
        <label for="action_id">{{ $t('actionlog.action_id') | capitalize }}:</label>
        <input
          id="action_id"
          name="id"
          type="number"
          min="0"
          step="1"
          style="width: 65%"
          v-model="actionId"
          :class="{'active': filtersActive && actionId}"
        />
      </div>
      <div class="field">
        <label for="input-dynamic-action-type-id">
          {{ $tc('models.dynamicactiontype', 1) | capitalize }}:
        </label>
        <div id="input-dynamic-action-type-id" class="input-select-field">
          <MultiSelect
            :options="Object.values(dynamicActionTypes)"
            v-model="dynamicActionType"
            track-by="id"
            label="name"
            :multiple="true"
            :close-on-select="false"
            placeholder=""
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
          />
        </div>
      </div>
      <div class="field">
        <label for="input-action-status-id">
          {{ $tc('models.actionstatus', 1) | capitalize }}:
        </label>
        <div id="input-action-status-id" class="input-select-field">
          <MultiSelect
            :options="Object.values(actionStatuses).sort((a, b) => Number(a.weight) - Number(b.weight))"
            v-model="actionStatus"
            track-by="id"
            label="name"
            :multiple="true"
            :close-on-select="false"
            placeholder=""
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
          />
        </div>
      </div>
      <div class="field">
        <label for="input-action-priority-id">
          {{ $tc('models.actionpriority', 1) | capitalize }}:
        </label>
        <div id="input-action-priority-id" class="input-select-field">
          <MultiSelect
            :options="Object.values(actionPriorities)"
            v-model="actionPriority"
            track-by="id"
            label="name"
            :multiple="true"
            :close-on-select="false"
            placeholder=""
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
          />
        </div>
      </div>
      <div class="field">
        <label for="input-created-by">
          {{ $t('model.created_by') | capitalize }}:
        </label>
        <div id="input-created-by" class="input-select-field">
          <MultiSelect
            :options="usersArray"
            v-model="createdBy"
            track-by="id"
            label="name"
            :multiple="true"
            :close-on-select="false"
            placeholder=""
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
          />
        </div>
      </div>
      <div class="field">
        <label for="input-city-district">
          {{ $t('model.city_district') | capitalize }}:
        </label>
        <div id="input-city-district" class="input-select-field">
          <MultiSelect
            :options="cityDistricts"
            v-model="cityDistrict"
            :multiple="false"
            :close-on-select="true"
            placeholder=""
            selectLabel=""
            selectedLabel=""
          />
        </div>
      </div>
      <div class="field">
        <label style="float: initial;">
          {{ $t('actionlog.period') | capitalize }}:
        </label>

        <div class="input-select-field">
          <span class="radio-option" style="width: 100%">
            <input type="radio"
                   id="filter-radio-created_at"
                   name="date"
                   value="created_at"
                   v-model="date"
            />
            <label class="filter-radio-label" for="filter-radio-created_at">
              {{ $t('model.created_at') | capitalize }}
            </label>
          </span>
          <br />
          <span class="radio-option" style="width: 100%">
            <input type="radio"
                   id="filter-radio-updated_at"
                   name="date"
                   value="updated_at"
                   v-model="date"
            />
            <label class="filter-radio-label" for="filter-radio-updated_at">
              {{ $t('model.updated_at') | capitalize }}
            </label>
          </span>
        </div>

        <label class="date-filter-label">
            {{ $t('actionlog.from') | capitalize }}:
        </label>
        <label class="date-filter-label">
            {{ $t('actionlog.to') | capitalize }}:
        </label>
        <input
          type="date"
          style="width: 50%"
          :class="{'active': filtersActive && fromDate}"
          v-model="fromDate"
        />
        <input
          type="date"
          style="width: 50%"
          :class="{'active': filtersActive && toDate}"
          v-model="toDate"
        />
      </div>
      <div class="field">
        <a @click="performFilter" class="filter success btn">
          {{ $t('actionlog.filter') }}
        </a>
        <a
          @click="performFilterReset"
          class="reset cancel btn"
        >
          {{ $t('actionlog.filter_reset') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import MultiSelect from 'vue-multiselect';

import EventBus from '@/events/event-bus';

import * as dataCache from '@/store/cache/dataCache';

export default {
  name: 'ActionFilter',
  components: {
    MultiSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    network_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      cityDistricts: [],
      filtersActive: false,
    };
  },
  computed: {
    ...mapGetters({
      actionPriorities: 'settings/getActionPriorities',
      actionStatuses: 'settings/getActionStatuses',
      dynamicActionTypes: 'settings/getDynamicActionTypes',
      users: 'settings/getUsers',
    }),
    usersArray() {
      return Object.values(this.users);
    },
    dynamicActionType: {
      get() {
        return this.$store.state.management.filter.dynamicActionType;
      },
      set(value) {
        this.$store.commit('management/setDynamicActionType', value);
      },
    },
    actionPriority: {
      get() {
        return this.$store.state.management.filter.actionPriority;
      },
      set(value) {
        this.$store.commit('management/setActionPriority', value);
      },
    },
    actionStatus: {
      get() {
        return this.$store.state.management.filter.actionStatus;
      },
      set(value) {
        this.$store.commit('management/setActionStatus', value);
      },
    },
    createdBy: {
      get() {
        return this.$store.state.management.filter.createdBy;
      },
      set(value) {
        this.$store.commit('management/setCreatedBy', value);
      },
    },
    cityDistrict: {
      get() {
        return this.$store.state.management.filter.cityDistrict;
      },
      set(value) {
        this.$store.commit('management/setCityDistrict', value);
      },
    },
    actionId: {
      get() {
        return this.$store.state.management.filter.actionId;
      },
      set(value) {
        this.$store.commit('management/setActionId', value);
      },
    },
    fromDate: {
      get() {
        return this.$store.state.management.filter.fromDate;
      },
      set(value) {
        this.$store.commit('management/setFromDate', value);
      },
    },
    toDate: {
      get() {
        return this.$store.state.management.filter.toDate;
      },
      set(value) {
        this.$store.commit('management/setToDate', value);
      },
    },
    date: {
      get() {
        return this.$store.state.management.filter.date;
      },
      set(value) {
        this.$store.commit('management/setDate', value);
      },
    },
  },
  methods: {
    performFilter() {
      let filter = '';
      if (this.dynamicActionType.length > 0) {
        filter += `&dynamic_action_type_id=(${this.dynamicActionType.map(item => item.id).join(',')})`;
      }
      if (this.actionPriority.length > 0) {
        filter += `&action_priority_id=(${this.actionPriority.map(item => item.id).join(',')})`;
      }
      if (this.actionStatus.length > 0) {
        filter += `&action_status_id=(${this.actionStatus.map(item => item.id).join(',')})`;
      }
      if (this.cityDistrict !== null && this.cityDistrict.length !== 0) {
        filter += `&geoObject-city_district=${this.cityDistrict}`;
      }
      if (this.createdBy !== null && this.createdBy.length > 0) {
        filter += `&created_by=(${this.createdBy.map(item => item.id).join(',')})`;
      }
      if (this.actionId !== null && this.actionId.length !== 0) {
        filter += `&id=${this.actionId}`;
      }
      if (this.fromDate) {
        const startDate = (Date.parse(this.fromDate) / 1000);
        if (!this.toDate) {
          filter += `&range=${startDate}`;
        } else {
          const endDate = (Date.parse(this.toDate) / 1000);
          filter += `&range=(${startDate},${endDate},${this.date})`;
        }
      }
      this.filtersActive = (filter.split('&').length - 1) > 0;
      this.$emit('performFilter', filter);
    },
    performFilterReset() {
      const { defaultFilter } = this.$store.state.management;
      this.dynamicActionType = defaultFilter.dynamicActionType;
      this.actionPriority = defaultFilter.actionPriority;
      this.actionStatus = defaultFilter.actionStatus;
      this.actionId = defaultFilter.actionId;
      this.cityDistrict = defaultFilter.cityDistrict;
      this.createdBy = defaultFilter.createdBy;
      this.date = defaultFilter.date;
      this.fromDate = defaultFilter.fromDate;
      this.toDate = defaultFilter.toDate;
      this.performFilter();
    },
    getCityDistricts() {
      this.cityDistricts = dataCache.getActionDistricts();
    },
  },
  mounted() {
    this.getCityDistricts();
    this.performFilter();
    EventBus.$on('ActionFilter.reset', () => {
      const { defaultFilter } = this.$store.state.management;
      this.dynamicActionType = defaultFilter.dynamicActionType;
      this.actionPriority = defaultFilter.actionPriority;
      this.actionStatus = defaultFilter.actionStatus;
      this.actionId = defaultFilter.actionId;
      this.cityDistrict = defaultFilter.cityDistrict;
      this.createdBy = defaultFilter.createdBy;
      this.date = defaultFilter.date;
      this.fromDate = defaultFilter.fromDate;
      this.toDate = defaultFilter.toDate;
    });
  },
};
</script>
<style scoped>
  .field {
    overflow: inherit;
  }

  .field label {
    width: 35%;
    display: inline-flex;
  }

  .field label.date-filter-label {
    width: 50%;
    text-align: center;
  }

  .field .input-select-field {
    width: 65%;
    overflow: inherit;
    display: inline-flex;
    float: initial;
  }

  .field input[type=number],.field input[type=date] {
    width: 65%;
    display: inline-flex;
    float: initial;
  }
  .field .btn.filter {
    float: initial;
  }

  .field .btn.reset {
    float: right;
  }

  .filter-radio-label {
    margin-left: 5px;
    width: auto;
    float: initial;
    line-height: normal;
  }
</style>
